export const FSF_PAGE = [
  '/en/book-flight',
  '/de/fluge-buchen',
  '/et/broneerige-lend',
  '/lv/rezervet-biletes',
  '/lt/uzsakyti-skrydzius',
  '/ru/kupit-aviabilety',
  '/fi/varaa-lennot',
  '/uk/bronyujte-aviakvitki'
]

export const POST_REQUEST_PAGES = [...FSF_PAGE]
export const INDEX_PAGE = '/index'

export const STATIC_PAGES = [INDEX_PAGE, ...FSF_PAGE]
